import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"

interface CommonUserApiStrategy {
  resourceEndpoint: string
  resourceQueryKey: string[]
  referentialEndpoint: (type: "list" | "create" | "update") => string
  sendVerifyMailEndpoint: (userId: string) => string
  exportFileName: string
}

export const apiRoleConf: RoleStrategy<CommonUserApiStrategy> = {
  [ROLES.ADMIN]: {
    resourceEndpoint: "/api/users",
    resourceQueryKey: ["users"],
    referentialEndpoint: (type) => `/api/users/referential/${type}`,
    sendVerifyMailEndpoint: (userId) => `/api/users/${userId}/verify-email`,
    exportFileName: "utilisateurs",
  },
  [ROLES.ADHERENT_HOLDER]: {
    resourceEndpoint: "/api/users/my-users/adherent",
    resourceQueryKey: ["users", "my-users", "adherent"],
    referentialEndpoint: (type) => `/api/users/referential/my-user/${type}`,
    sendVerifyMailEndpoint: (userId) =>
      `/api/users/my-users/adherent/${userId}/verify-email`,
    exportFileName: "", // no export allowed
  },
  [ROLES.ADHERENT_TEAM]: {
    resourceEndpoint: "/api/users/my-users/adherent",
    resourceQueryKey: ["users", "my-users", "adherent"],
    referentialEndpoint: (type) => `/api/users/referential/my-user/${type}`,
    sendVerifyMailEndpoint: () => "",
    exportFileName: "", // no export allowed
  },
}
